import { Grid, GridItem, ResponsiveColumns } from "@/ui/structure/Grid"
import { FormDefinition } from "../../types"
import CustomFormField from "../CustomFormField"
import CustomFormCta from "../CustomFormCta"
import CustomFieldError, { FieldErrorType } from "../CustomFormFieldError"
import {
  FieldError,
  FieldValues,
  FormState,
  UseFormRegister,
} from "react-hook-form"
import CustomFormFieldLabel from "../CustomFormFieldLabel"

const parseSpan = (span?: string | number): number => {
  if (typeof span === "string") {
    return parseInt(span)
  }

  return span ?? 1
}

const toError = (error?: FieldError): FieldErrorType | undefined => {
  if (error?.type === "required") {
    return "required"
  }
  if (error?.type === "email") {
    return "format"
  }
}

export interface CustomFormProps<T> {
  definition: FormDefinition<T>
  gridColumns?: ResponsiveColumns
  formState: FormState<FieldValues>
  registerField: UseFormRegister<FieldValues>
  onSubmit: () => void
  loading: boolean
}

const CustomForm = <T,>({
  definition,
  formState,
  registerField,
  onSubmit,
  loading,
  gridColumns,
}: CustomFormProps<T>) => {
  return (
    <div>
      <Grid cols={gridColumns} className="gap-y-12">
        {definition.fields
          .filter((field) => field.type !== "hidden")
          .map((field) => (
            <GridItem
              key={field.name}
              colSpan={{
                xs: 1,
                sm: parseSpan(field.colSpan),
              }}
            >
              <CustomFormFieldLabel definition={field} className="px-8 pb-4" />
              <CustomFormField
                definition={field}
                registerField={registerField}
              />
              {formState.errors?.[field.name] && (
                <CustomFieldError
                  error={toError(formState.errors?.[field.name] as FieldError)}
                  field={field}
                />
              )}
            </GridItem>
          ))}
      </Grid>
      <div className="mt-12 flex justify-center">
        <CustomFormCta
          label={definition.cta.label}
          loading={loading}
          onClick={onSubmit}
        />
      </div>
    </div>
  )
}

export default CustomForm
